<template>
    <div id="welcome_to_ilkb" class="module-container module-container-welcome">
        <div class="container">
            <div class="row flex-row-reverse">
                <section class="section-container col-40-lg">
                    <div class="element-contaier">
                        <img 
                            src="https://res.cloudinary.com/ilovekickboxing/image/upload/v1727889581/ILKB_-_Main_Image_1_w93pm6.png" alt="Man smiling while leaning against bag" class="img-fluid">
                    </div>
                </section>
                <section class="section-container col-60-lg">
                    <div class="element-contaier">
                        <h2 class="element-text text-align-left font-size-88 font-size-mobile-60">Group Fitness Classes that Bring the Energy</h2>
                    </div>
                    <div class="element-contaier">
                        <!-- Modified paragraph element to include role="heading" for visually appearing titles -->
                        <p class="element-text text-align-left font-size-20">
                            <span>
                                Not all gyms are created equal. Our high-energy workout classes deliver powerful results while helping you unleash your inner strength. Burn calories, sweat away stress, and discover a fitness studio where you can truly let go and be yourself. 
                            </span>
                        </p>
                    </div>
                    <div class="element-contaier">
                        <!-- Modified paragraph element to include role="heading" for visually appearing titles -->
                        <p class="element-text text-align-left font-size-20">
                            <span>
                               We're all about fitness, community, and lifting each other up. Whether you're just getting started or looking for something new, you'll find your place here. From the supportive coaches who help you push beyond your limits to the people sweating it out alongside you, every 45-minute workout is a team effort—where encouragement and energy fuel your journey.
                            </span>
                        </p>
                    </div>
                    <div class="element-contaier">
                        <a href="/action-packed-workout" class="">
                            <button type="button" class="btn btn-primary"> Explore the Workout</button>
                        </a>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>